import { render, staticRenderFns } from "./BookChartFarms.vue?vue&type=template&id=04932c9a&"
import script from "./BookChartFarms.vue?vue&type=script&lang=js&"
export * from "./BookChartFarms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports